export default __webpack_public_path__ + "static/media/overcoat.b7d5752a.svg";